<template>
  <v-main>
    <v-container>
      <v-row>
        <v-col>
          <h1
            class="
              text-lg-h4 text-h6 text-color-title text-center
              font-weight-bold
            "
          >
            Introduction
          </h1>
          <p class="text-center px-lg-10">
            'VBRT' stands for Virtual Brand Representative Training that aims to
            provide the updated product information, function and sales
            technique in order to support your sale and marketing team to expand
            La-Z-Boy products to the market.
          </p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <video
            src="https://lazboyasiaconf.com/videos/2022/training/LAZBOY_EP1.mov"
            :poster="require('@/assets/training/2022/1.png')"
            controls
          />
          <h1 class="text-lg-h4 text-h6 text-color-title font-weight-bold text-center">
            Approaching to Customer's Heart
          </h1>
        </v-col>
      </v-row>
      <v-row class="my-md-5">
        <v-col cols="12" md="6">
          <video
            src="https://lazboyasiaconf.com/videos/2022/training/LAZBOY_EP2.mov"
            :poster="require('@/assets/training/2022/2.png')"
            controls
          />
          <h1 class="text-lg-h4 text-h6 text-color-title font-weight-bold text-center">
            Identify Customer's Need
          </h1>
        </v-col>
        <v-col md="6" class="align-self-end">
          <video
          src="https://lazboyasiaconf.com/videos/2022/training/LAZBOY_EP3.mov"
            :poster="require('@/assets/training/2022/3.png')"
            controls
          />
          <h1 class="text-lg-h4 text-h6 text-color-title font-weight-bold text-center">
            Sales Scenarios
          </h1>
        </v-col>
      </v-row>
      <v-row class="mt-md-5">
        <v-col cols="12" md="6">
          <video
          src="https://lazboyasiaconf.com/videos/2022/training/LAZBOY_EP4.mov"
            :poster="require('@/assets/training/2022/4.png')"
            controls
          />
          <h1 class="text-lg-h4 text-h6 text-color-title font-weight-bold text-center">
            Close A Sale
          </h1>
        </v-col>
        <v-col lg="6" class="align-self-end">
          <video
          src="https://lazboyasiaconf.com/videos/2022/training/LAZBOY_EP5.mov"
            :poster="require('@/assets/training/2022/5.png')"
            controls
          />
          <h1 class="text-lg-h4 text-h6 text-color-title font-weight-bold text-center">
            Cover
          </h1>
        </v-col>
      </v-row>
      <!-- <div class="question-box p-6 mt-6">
        <v-row>
          <v-col cols="12" xs="12" sm="6">
            <v-text-field placeholder="Enter your name" solo></v-text-field>
            <v-text-field
              placeholder="Enter you valid email address"
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6">
            <textarea class="textarea" placeholder="Enter your message">
            </textarea>
          </v-col>
        </v-row>
        <div class="text-center mt-6">
          <button class="button is-primary px-12 py-2" @click="submit">
            Submit
          </button>
          <v-dialog
            transition="dialog-top-transition"
            max-width="600"
            v-model="dialog"
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-card-text class="pt-6">
                  <v-img
                    max-width="250"
                    class="m-auto"
                    :src="require('@/assets/logo.png')"
                  />
                  <div class="text-h6 pa-lg-6 text-center">
                    Thank you for your question. <br />We will get back to your
                    shortly.
                  </div>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn text @click="dialog.value = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </div>
      </div> -->
    </v-container>
  </v-main>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    submit() {
      this.dialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.question-box {
  background-color: rgb(21 101 192 / 62%);
  border-radius: 20px;
  color: white;
}

.v-text-field__details {
  display: none;
}

.text-lg-h4,
.text-h6 {
  font-style: italic;
}
.textarea {
  background: white;
  border-radius: 4px;
  width: 100%;
  padding: 10px;
  height: 80%;
  color: #666666;
}
.textarea::placeholder {
  color: #6da6b5;
}
</style>
